import type { CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";

export const removeCouponMutationKey = ["removeCoupon"] as const;

export function useRemoveCoupon() {
  const cartClient = useServicesStore(state => state.cartClient);
  const cartId = useGlobalStore(state => state.cartId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: removeCouponMutationKey,
    mutationFn: async (): Promise<CartOutputDto> => {
      if (!cartClient) throw new Error("Cart client is not available.");
      if (!cartId) throw new Error("Cart id is not available.");
      return await cartClient.postCouponCode(cartId, null);
    },
    onSuccess: cart => {
      queryClient.setQueriesData<CartOutputDto | null>(CART_ACTIVE_FILTER, cart);
    },
  });
}
